import React, { useMemo } from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const ObjectStructuresField =  React.memo(({
    className,
    receiverCode,
    name = "destination_object_code",
    label = "Object Type *",
    ...restProps
}) => {
    const params = useMemo(() => ({ receiverCode }), [ receiverCode ]);

    return (
        <SelectEntityByType
            className={className}
            name={name}
            FieldsTypes={FiltersFieldsTypes.objectStructures}
            isReloadAllTime
            params={params}
            label={label}
            {...restProps}
        />
    );
});
